import { apiFetch } from './client';

export const listLanguages = (token) => apiFetch(token, '/languages');

export const createLanguage = (token, payload) =>
  apiFetch(token, '/languages', { method: 'POST', body: JSON.stringify(payload) });

export const updateLanguage = (token, languageId, payload) =>
  apiFetch(token, `/languages/${languageId}`, { method: 'PATCH', body: JSON.stringify(payload) });

export const deleteLanguage = (token, languageId) =>
  apiFetch(token, `/languages/${languageId}`, { method: 'DELETE' });
